





















































































































import { Component, Mixins, Watch, Vue } from "vue-property-decorator";

import ObjectEditLayout from "@service/layouts/ObjectEditLayout.vue";
import LangSelector from "@share/common/controls/lang-selector/LangSelector.vue";
import UserSelectInput from "@share/common/form/form-controls/stub/UserSelectInput.vue";
import BorderlessTextarea from "@share/common/form/form-controls/text/BorderlessTextarea.vue";
import DateTimeControl from "@share/common/form/form-controls/date/date-time/DateTimeControl.vue";
import FormGroup from "@share/common/form/form-group/FormGroup.vue";
import BackButton from "@service/components/common/back-button/BackButton.vue";
import PeopleSelect from "@share/common/form/form-controls/select/people-select/PeopleSelect.vue";
import TextSelect from "@share/common/form/form-controls/select/variations/text-select/TextSelect.vue";
import TagSelect from "@share/common/form/form-controls/select/variations/tag-select/TagSelect.vue";
import SingleSelect from "@share/common/form/form-controls/select/variations/single-select/SingleSelect.vue";
import BorderlessText from "@share/common/form/form-controls/text/BorderlessText.vue";
import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";
import TzSelector from "@share/common/tz-selector/TZ-selector.vue";
import E404 from "@service/views/errors/e404.vue";

import { validationMixin } from "vuelidate";
import { repositories } from "@service/api/Repositories";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { SelectObjectSourceService } from "@share/common/services/selectControl/SelectObjectSourceService"
import { UserProfile } from "@api/models/UserProfile";
import { DropDownItem } from "@share/common/drop-down/types";
import { getSelectSourcesQuery, getSessionFormSelectSources, getTypesList, getValidationObject } from "./data";
import { SessionEditFormSelectSourses } from "./types";
import { SessionAdminService } from "./services/SessionAdminService";
import { SessionEditModel } from "@api/models/session/SessionEditModel";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { DateTime } from "luxon";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import { SessionTypeEnum } from "@api/enums/Session/SessionTypeEnum";
import { Debounce } from "vue-debounce-decorator";
import { parseJson } from "@common/TypesHelper";
import { convertToDateTime, dateInOriginalOffset } from "@common/dateTimeHelper";
import { UnloadService } from "@share/common/services/unloadService/UnloadService";
import { getInvalidLangs } from "@common/form/lang";
import TimeCircle from "../../assets/svg/time-circle.svg";
import { mainActions } from "@service/store/main/actions";
import { RootState } from "@service/store/types/RootState";

@Component({
    components: {
        AdminPanel, BorderlessText,
        BackButton, BorderlessTextarea, DateTimeControl, E404, FormGroup,
        LangSelector, ObjectEditLayout, PeopleSelect, SingleSelect,
        TagSelect, TextSelect, TzSelector, UserSelectInput, TimeCircle
    },
    validations() {
        return getValidationObject((this as SessionEdit).langList);
    }
})

export default class SessionEdit extends Mixins(validationMixin) {
    //schemas
    agendaSchemaId = process.env.VUE_APP_AGENDA_SCHEMA!
    exhibitionSchemaId = process.env.VUE_APP_EXHIBITION_SCHEMA! || "Exhibition";
    groupsSchemaId = "Groups";
    tagsSchemaId = this.$store.getters['events/selectedEventViewParam']('stage', null)?.sessionTagsSchemaId;

    selectedLang = this.lang;
    notFoundError = false;

    //select sources
    searchedSources: SessionEditFormSelectSourses = getSessionFormSelectSources();
    selectedListSources: SessionEditFormSelectSourses = getSessionFormSelectSources();
    onlineProviderSource: any[] = getTypesList();
    OnlineProvider = OnlineProvider;

    selectSourceService: SelectObjectSourceService | null = null;
    adminService: SessionAdminService | null = null;

    //session model
    session: SessionEditModel | null = null;
    unloadService: UnloadService | null = null;
    resetable = false;

    //user select
    showUserSelect = false;
    speakers: UserProfile[] = [];
    userSelectElement: HTMLElement | null = null;
    rightSideStyle: string | null = null;
    originSpeakers: UserProfile[] = [];

    @Watch('session', { deep: true })
    watchSession() {
        this.resetable = !!this.session?.needReset;
    }

    get selectedTimeZone() {
        return (this.$store.state as RootState).selectedTimeZoneOffset?.toString() || "";
    }

    set selectedTimeZone(value: string) {
        this.$store.dispatch(mainActions.setSelectedTimeZone, value);
    }

    get onlineProvider(): DropDownItem {
        return this.onlineProviderSource.find((item) => item.id === this.session?.onlineProvider) || { title: "", id: this.session?.onlineProvider }
    }

    set onlineProvider(value: DropDownItem) {
        if(this.session) {
            this.session.onlineProvider = value.id as OnlineProvider;
            const link = this.session.link;
            this.session.link = link;
        }
    }

    get tagsIds(): DropDownItem[] {
        return this.selectedListSources.tags.filter((item) => this.session?.tagsIds?.includes(item.id || ""))
    }

    set tagsIds(value: DropDownItem[]) {
        this.selectedListSources.tags = value || [];
        if(this.session?.tagsIds && value) {
            this.session.tagsIds = value.map((item) => item.id || "") || [];
        }
    }

    get partnerId(): DropDownItem {
        return this.selectedListSources.partner.find((item) => item.id === this.session?.partnerId) || { title: "", id: this.session?.partnerId || ""  }
    }

    set partnerId(value: DropDownItem) {
        this.selectedListSources.partner = [value];
        if(this.session) {
            this.session.partnerId = value.id || null;
        }
    }

    get groupIds() {
        return this.selectedListSources.groups.filter((item) => this.session?.groupIds?.includes(item.id || ""))
    }

    set groupIds(value: DropDownItem[]) {
        this.selectedListSources.groups = value || [];
        if(this.session?.groupIds) {
            this.session.groupIds = value.map((item) => item.id || "");
        }
    }

    get vSession() {
        return this.$v.session
    }

    get $vTitle() {
        return this.vSession[`title.${this.selectedLang}`]
    }

    get $vDescriptionModel() {
        return this.vSession[`description.${this.selectedLang}`]?.$model
    }

    set $vDescriptionModel(value: string) {
        const desc = this.vSession[`description.${this.selectedLang}`];
        if(desc) {
            desc.$model = value
        }
    }

    get $vType() {
        return this.vSession[`type.${this.selectedLang}`];
    }

    get showLink() {
        return this.onlineProvider.id !== OnlineProvider.webConference && this.onlineProvider.id !== OnlineProvider.agora && this.onlineProvider.id !== OnlineProvider.liveKit;
    }

    updateTypeForAllLangs(item: DropDownItem) {
        this.langList.forEach((lang) => {
            const $vtype = this.vSession[`type.${lang}`];
            if($vtype && item.id) {
                $vtype.$model = this.$t(`program.${item.id}`, lang).toString();
            }
        })
    }

    updateBegin(value: DateTime) {
        if(this.session && value.isValid) {
            this.session.beginAt = value;
        }
    }

    updateEnd(value: DateTime) {
        if(this.session && value.isValid) {
            this.session.endAt = value
        }
    }

    async mounted() {

        this.selectSourceService = new SelectObjectSourceService(repositories.get(RepositoryFabric.OBJECT));
        this.adminService = new SessionAdminService(
            this.agendaSchemaId,
            repositories.get(RepositoryFabric.OBJECT),
            repositories.get(RepositoryFabric.SETTING),
            repositories.get(RepositoryFabric.EVENT_MEMBERSHIP),
            this.$store
        );
        this.unloadService = new UnloadService(this, "resetable", this.$t('agenda.form.goBackConfirmation').toString());

        await this.adminService.init();

        // id есть
        //загружаем сессию
            //сессия есть
                // заполняем поля
            //сессия 404
                //показ 404

        if(this.isOnEdit) {
            if(this.sessionId) {

                let sessions = await this.adminService.getSessionByLangs(this.sessionId, this.langList) || null;

                /**
                 * geting select control list sources
                 */
                this.adminService.getSessionRefs(getSelectSourcesQuery(this.sessionId)).then((data) => {
                    const sources = data?.[0];
                    if(sources) {
                        this.selectedListSources.groups = typeof sources.groupIds === "string" ? parseJson(sources.groupIds) : sources.groupIds ?? [] as DropDownItem[];
                        this.selectedListSources.tags = typeof sources.tagsIds === "string" ? parseJson(sources.tagsIds) : sources.tagsIds ?? [] as DropDownItem[];
                        this.selectedListSources.partner = typeof sources.partnerId === "string" ? [parseJson(sources.partnerId)] : [sources.partnerId] as DropDownItem[];
                    }
                })

                let speakers = await this.adminService.getSpeakers(this.sessionId);

                //привязка должна быть в модели
                this.originSpeakers = this.speakers = speakers as UserProfile[];
                const speakersIds = speakers?.map((userProfile) => userProfile.userId || 0) || [];
                // загрузка eventMembership

                if(sessions) {
                    this.session = Vue.observable(new SessionEditModel(sessions, speakersIds ?? [], this.selectedTimeZone));

                    //задание значения времени в ручную
                    this.$nextTick(() => {
                        this.setTime();
                    });

                    //clear memory
                    sessions = null;
                }

                else {
                    this.show404()
                }
            }
            else {
                this.show404()
            }
        }
        else {
            this.initForm();
        }

        this.selectedLang = this.langList[0];
    }

    @Debounce(500)
    async save() {
        if(this.session) {

            this.touch();

            const dateTimeControl = (this.$refs["dateTimeControl"] as DateTimeControl | undefined);
            const formIsValid = !this.$v.$invalid && !(dateTimeControl && dateTimeControl.$v.$invalid);

            if(formIsValid) {
                this.session.eventId = this.eventId;

                const id = await this.adminService?.save(this.sessionId, this.session, this.lang);

                if(id) {
                    this.unloadService?.unsubscribe();
                    this.createHandler();
                }
            }
        }
    }

    setTime() {
        let beginAt = convertToDateTime(this.session?.beginAt);
        let endAt = convertToDateTime(this.session?.endAt);
        if(beginAt && endAt) {
            beginAt = dateInOriginalOffset(beginAt, parseInt(this.selectedTimeZone))
            endAt = dateInOriginalOffset(endAt, parseInt(this.selectedTimeZone));

            (this.$refs["dateTimeControl"] as DateTimeControl | undefined)?.setValue(beginAt, endAt)
        }
    }

    resetTime() {
        (this.$refs["dateTimeControl"] as DateTimeControl | undefined)?.setValue(undefined, undefined)
    }

    createHandler() {
        this.$router.push({
            name: RouteNamesEnum.home,
            params: {
                eventId: this.$route.params.eventId,
                backend: this.$route.params.backend
            }
        })
    }

    initForm() {
        this.session = null;
        const langFields = this.langList.reduce((acc, current) => ({ ...acc, ...{[current]: {}} }),{});

        this.session = Vue.observable(new SessionEditModel(langFields, [], this.selectedTimeZone));
        //предзаполнение типа сессии
        if(this.$route.params.sessionType) {
            this.onlineProvider = this.onlineProviderSource.find((item) => item.id === this.$route.params.sessionType);
        }

        this.session.resetCopy();
    }

    back() {
        this.$router.push({
            name: RouteNamesEnum.home,
            params: {
                eventId: this.$route.params.eventId,
                backend: this.$route.params.backend
            }
        })
    }

    // reset() {
    //     this.session?.reset();
    //     this.speakers = this.originSpeakers;
    //     this.setTime();
    // }

    // resetSessionCopy() {
    //     this.session?.resetCopy();
    //     this.watchSession();
    //     this.originSpeakers = this.speakers;
    // }

    cleanForm() {
        this.adminService && (this.adminService.speakersMemberships = []);
        this.resetTime();
        this.initForm();
    }

    typesSearch(keyword: string) {
        this.onlineProviderSource = getTypesList().filter((item) => item.title.toLowerCase().includes(keyword.toLowerCase()));
    }

    show404() {
        this.notFoundError = true
    }

    get groupsSource() {
        return this.searchedSources.groups;
    }

    get partnersSource() {
        return this.searchedSources.partner;
    }

    get sessionTagsSource() {
        return this.searchedSources.tags;
    }

    async tagsSearch(keyword = "") {
        this.searchedSources.tags = await this.selectSourceService?.getSelectSource({ keyword, schemaId: this.tagsSchemaId, withoutParents: true, keywordLength: 0 }) || [];
    }

    async partnersSearch(keyword = "") {
        this.searchedSources.partner = await this.selectSourceService?.getSelectSource({ keyword, schemaId: this.exhibitionSchemaId, eventId: this.eventId, withoutParents: true, keywordLength: 0 }) || [];
    }

    async groupsSearch(keyword = "") {
        this.searchedSources.groups = await this.selectSourceService?.getSelectSource({ keyword, schemaId: this.groupsSchemaId, keywordLength: 0 }) || [];
    }

    get speakersName() {
        return this.speakers.map((speaker) => speaker.fullName).join(', ')
    }

    @Watch('showUserSelect')
    watchShowUserSelect(value: boolean) {
        if(!value) {
            this.userSelectElement = null;
        }
        else {
            this.$nextTick(() => {
                this.userSelectElement = (this.$refs.userSelect as HTMLElement | null)
            })
        }
    }

    @Watch('speakers')
    watchSpeakers(value: any[]) {
        if(this.session) {
            this.session.speakerUserIds = value.map((item) => item.userId)
        }
    }

    @Watch('$route.name')
    watchRouteName(currentRouteName: string, prevRouteName: string) {
        if(prevRouteName === RouteNamesEnum.sessionEdit && currentRouteName === RouteNamesEnum.sessionCreate) {
            this.cleanForm();
        }
    }

    touch() {
        this.$v.$touch();
        (this.$refs["dateTimeControl"] as DateTimeControl | undefined)?.validate();
    }

    get invalidlangs() {
        return getInvalidLangs(this.$v.session);
    }

    get isOnEdit() {
        return this.$route.name === RouteNamesEnum.sessionEdit;
    }

    get sessionId(): string | undefined {
        return this.$route.params.id
    }

    get refs(): Record<string, { $el: HTMLElement }> {
        return (this.$refs as any as Record<string, { $el: HTMLElement }>) || {}
    }

    get langList(): string[] {
        return this.adminService?.languages || [];
    }

    get eventId(): string {
      return this.$store.state.events.selected;
    }

    get lang() {
        return this.$store.getters['language'];
    }

    private get isAdmin(): boolean {
        return this.$store.getters['isAdmin'];
    }

    // move to own file
    get typeList(): DropDownItem[] {
        return [
            {
                title: this.$t(`program.${SessionTypeEnum.roundtable}`).toString(),
                id: SessionTypeEnum.roundtable.toString()
            },
            {
                title: this.$t(`program.${SessionTypeEnum.speakersQA}`).toString(),
                id: SessionTypeEnum.speakersQA.toString()
            },
            {
                title: this.$t(`program.sessionWithoutArticle`).toString(),
                id: 'sessionWithoutArticle'
            }
        ]
    }

    get offset() {
        return this.$store.state.timeZoneOffset.toString();
    }

    get blockNoLangFields() {
        return this.selectedLang !== (this.adminService?.languages?.[0] || 'en')
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    beforeDestroy() {
        this.unloadService?.unsubscribe();
    }
}

